import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=3c8fb907&"
import script from "./DeleteUser.vue?vue&type=script&lang=js&"
export * from "./DeleteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports